import React from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import cx from 'classnames';
import moment from "moment";
import { ElementsConsumer } from "@stripe/react-stripe-js";
import { useQuery } from "@apollo/client";
import withStyles from "isomorphic-style-loader/withStyles";

import ServicePlansInformation from "../../../components/ServicePlanContainer/ServicePlansPayment/ServicePlansInformation";
import ServicePlansBookForm from "../../../components/ServicePlanContainer/ServicePlansPayment/ServicePlansBookForm";
import Loader from "../../../components/Loader/Loader";
import NotFound from "../../notFound/NotFound";

import messages from "../../../locale/jsonMessages";
import { getPaymentMethods, getPaymentServicePlan } from "../../../lib/graphql/servicePlans";
import { dateFormat } from "../../../config";

//Style
import cs from '../../../components/commonStyle.css';
import s from '../../../routes/userServicePlan/ServicePlanPayment/ServicePlanPayment.css';

const ServicePlansReturnPayment = (props) => {
    const { id, account } = props;
    const intl = useIntl();

    const { data, loading } = useQuery(getPaymentServicePlan, {
        variables: { id: Number(id) },
        fetchPolicy: 'network-only',
        ssr: false,
    });

    const { data: getPaymentMethodData, loading: getPaymentMethodLoading } = useQuery(getPaymentMethods, {
        fetchPolicy: 'network-only',
        ssr: false,
    });

    if (loading || getPaymentMethodLoading) {
        return <div><Loader type={"text"} /></div>;
    }


    if ((!loading && data?.getPaymentServicePlan?.status === 400) || (!loading && !data?.getPaymentServicePlan?.result?.servicePlanData)) {
        return <NotFound />;
    }

    if (!loading && data?.getPaymentServicePlan?.status === 200) {

        const paymentMethods = getPaymentMethodData?.getPaymentMethods;

        const today = data && data?.getPaymentServicePlan?.result?.startDate;
        const endDate = data && data?.getPaymentServicePlan?.result?.endDate;

        const startDate = today ? moment(parseInt(today)).format(dateFormat?.shortDateFormat) : '';
        const lateDate = endDate ? moment(parseInt(endDate)).format(dateFormat?.shortDateFormat) : '';

        let initialValues = {
            id: data && data?.getPaymentServicePlan?.result?.id,
            paymentType: data && String(data?.getPaymentServicePlan?.result?.paymentType),
            price: data && data?.getPaymentServicePlan?.result?.price,
            currency: data && data?.getPaymentServicePlan?.result?.currency,
            userType: data && data?.getPaymentServicePlan?.result?.userType,
            startDate: startDate,
            lateDate: lateDate,
            serviceFee: data && data?.getPaymentServicePlan?.result?.serviceFee,
            duration: data && data?.getPaymentServicePlan?.result?.duration,
            servicePlanId: data && data?.getPaymentServicePlan?.result?.servicePlanId,
            servicePlanName: data && data?.getPaymentServicePlan?.result?.servicePlanName,
            serviceDescription: data && data?.getPaymentServicePlan?.result?.serviceDescription,
            serviceAIFeature: data && data?.getPaymentServicePlan?.result?.serviceAIFeature,
            userId: account?.userId
        };

        return (
            <div className={s.servicePlanPaymentContainer}>
                <div className={s.container}>
                    <h1 className={cx(cs.commonTitleText, cs.paddingBottom4)}>{intl?.formatMessage(messages.reviewAndPayLabel)}</h1>
                    <div className={s.servicePlanPaymentRow}>
                        <div className={s.servicePlanPaymentCol1}>
                            <ElementsConsumer>
                                {({ stripe, elements }) => (
                                    <ServicePlansBookForm
                                        data={paymentMethods}
                                        initialValues={initialValues}
                                        stripe={stripe}
                                        elements={elements}
                                        isCancel={true}
                                    />
                                )}
                            </ElementsConsumer>
                        </div>
                        <div className={s.servicePlanPaymentCol2}>
                            <ServicePlansInformation
                                data={data?.getPaymentServicePlan?.result?.servicePlanData}
                                startDate={startDate}
                                lateDate={lateDate} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return null;
}

const mapState = (state) => ({
    account: state.account.data
});

const mapDispatch = {};

export default withStyles(cs, s)(connect(mapState, mapDispatch)(ServicePlansReturnPayment));
